import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShowIfPermissionDirective } from './show-if-permission.directive';
import { DragDropDirective } from './drag-drop.directive';
import { MultipleEmailValidatorDirective } from './multiple-email-validator.directive';
import { NumbersOnlyDirective } from './number-only.directive';
@NgModule({
  declarations: [
    ShowIfPermissionDirective,
    DragDropDirective,
    MultipleEmailValidatorDirective,
    NumbersOnlyDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ShowIfPermissionDirective,
    DragDropDirective,
    MultipleEmailValidatorDirective,
    NumbersOnlyDirective,
  ]
})
export class DirectivesModule { }
